/* eslint-disable no-param-reassign */
import Wizard from './wizard';
import Helpers from './helpers';

const WizardFormSubmit = {
	form: null,
	// wire everything up
	init({ form }) {
		Wizard.init();
		if (form) {
			this.form = form;
			// add custom event to listen if it's time to submit
			window.addEventListener('submit-form', () => {
				Helpers.disableAllButtons();
				this.handleFormSubmit();
			});
		}
	},

	handleFormSubmit() {
		Helpers.saveCodeMirrorInput();
		this.form.submit();
	},
};

export { WizardFormSubmit as default };
